import React from "react";
import Videos from "../components/Videos";
import NEWS from "../assets/backup/news.json";

const NewsPage = () => {
	return (
		// *TODO: make api request
		<Videos
			videos={NEWS}
			imgUrl={
				"https://user-images.githubusercontent.com/47064842/115323561-5d545780-a156-11eb-900b-774701c03189.png"
			}
		/>
	);
};
export default NewsPage;
